/* eslint-disable react/no-danger */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import SrtIcon from '@src/assets/images/srt-icon.svg';
import { useLocation } from 'react-router-dom';
import CustomTypography from '@src/new-components/Typography';
import FileCopyRoundedIcon from '@mui/icons-material/FileCopyRounded';
import { useSelector } from 'react-redux';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import SrtFailIcon from '@src/assets/icons/srt-fail.svg';
import { getShortFileName } from '@src/services/file';
import {
  DUBBING_LENGTH_LIMIT,
  MAX_SENTENCE_LENGTH,
  SUBTITLE_SAMPLE_LINK_PROJECT,
} from '@src/constants/dubbing';
import { MAX_CHARACTER_LENGTH } from '@src/constants/tts';

import { StyledFailedDropzoneContent } from './index.style';
import SampleFileReference from './SampleFileReference';

const FailedDropzoneContent = ({
  fileName,
  error = {},
  fileFormat,
  dubbingFileFormat,
  isMultipleInputDubbing,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isCreateSrtProjectPage = location.pathname.includes('/projects');
  const { user } = useSelector((state) => state.auth);

  const { getFeatureValue } = useFeatureFlags();

  const createSrtProjectEnabled = getFeatureValue(
    FEATURE_KEYS.CREATE_SRT_PROJECT,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const contentUploadFileSrt = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        textAlign: 'center',
      }}
    >
      <CustomTypography variant="body-16-medium" color="#101323">
        {t('titleUploadFileSrt')}
      </CustomTypography>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          justifyContent: 'center',
        }}
      >
        <CustomTypography variant="body-14-regular" color="#1C1C1EA3">
          {t('referToSampleFileSrt')}
        </CustomTypography>
        <FileCopyRoundedIcon
          sx={{
            fontSize: '20px',
            color: '#1E164E',
          }}
        />
        <a
          href={SUBTITLE_SAMPLE_LINK_PROJECT}
          download
          className="sample-file"
          onClick={(e) => e.stopPropagation()}
          style={{
            color: '#000000CC',
            fontSize: '14px',
          }}
        >
          {t('sampleFileName')}.srt
        </a>
      </div>
    </div>
  );

  const OldDropzone = () => (
    <>
      <img
        src={
          createSrtProjectEnabled && isCreateSrtProjectPage
            ? SrtIcon
            : SrtFailIcon
        }
        alt="srt-icon"
      />
      {createSrtProjectEnabled && isCreateSrtProjectPage ? (
        contentUploadFileSrt()
      ) : (
        <>
          <Typography className="file-name">
            {getShortFileName(fileName)}
          </Typography>
          <div className="upload-instruction">
            <Typography
              align="center"
              variant="h5"
              className="upload-file-title"
            >
              {t('dropFileSuccessInstruct', { fileFormat })}
            </Typography>
            <SampleFileReference />
          </div>
        </>
      )}
    </>
  );

  const NewDropzone = () => (
    <>
      <img src={SrtFailIcon} alt="srt-icon" />
      <div className="upload-instruction">
        <Typography
          align="center"
          variant="h5"
          className="upload-file-title text-blue"
        >
          {t('dropFileSuccessInstructSubtitle', { fileFormat })}
        </Typography>
        <SampleFileReference isMultipleInputDubbing />
      </div>
    </>
  );

  return (
    <StyledFailedDropzoneContent>
      {isMultipleInputDubbing ? <NewDropzone /> : <OldDropzone />}
      <div className="error">
        <div
          style={{
            ...(createSrtProjectEnabled &&
              isCreateSrtProjectPage && {
                textAlign: 'center',
                marginBottom: '24px',
                padding: '0 12px',
              }),
          }}
          className="error-text"
          dangerouslySetInnerHTML={{
            __html: t(error.message, {
              maxAudioLength: DUBBING_LENGTH_LIMIT,
              fileType: dubbingFileFormat?.map((type) => `.${type}`)?.join(','),
              maxSentenceLength: MAX_SENTENCE_LENGTH,
              maxCharacterLength: MAX_CHARACTER_LENGTH,
            }),
          }}
        />
        {error.detail && (
          <div
            className="error-detail-wrapper"
            role="button"
            onClick={(e) => e.stopPropagation()}
            tabIndex={0}
          >
            <div
              className="error-detail"
              dangerouslySetInnerHTML={{
                __html: t(error.detail),
              }}
            />
          </div>
        )}
      </div>
    </StyledFailedDropzoneContent>
  );
};
export default FailedDropzoneContent;
